import { render } from "./knowledge-bases.vue?vue&type=template&id=6c4cdab6"
import script from "./knowledge-bases.vue?vue&type=script&lang=js"
export * from "./knowledge-bases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__